import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

/** Entrada pública do canal de denúncias: para onde aponta o botão do site da GBT. */
@Component({
  selector: 'app-canal-denuncias',
  imports: [RouterLink],
  templateUrl: './canal-denuncias.html',
})
export class CanalDenuncias {
  protected readonly tenant = inject(ActivatedRoute).snapshot.paramMap.get('tenant') ?? '';
}
